// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hw-it-wrk-tlt{
    font-size: 50px;
    font-weight: 700;
    color: #000;
}

.work_main-tsc{
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.8rem;
}

.work-grp-btn{
    border: 3px solid #234B9A;
    width: 490px;
    height: 69px;
    display: flex;
    border-radius: 70px;
}
.work_brn1-fns{
    border: none;
    background-color: transparent;
    width: 50%;
    height: 100%;
    font-size: 32px;
    font-weight: 600;
    color: #000;
}

.farm-btn{
    border-top-left-radius: 70px;
    border-bottom-left-radius: 70px;
    background-color: #234B9A;
    color: #fff;
}
.stack-btn{
    border-top-right-radius: 70px;
    border-bottom-right-radius: 70px;
    background-color: #234B9A;
    color: #fff;
}

.frm-img-rgt{
    display: flex;
    justify-content: center;
}

.frm-img-rgt img{
    width: 100%;
    margin-top: 2rem;
}
.stck-p-txt{
    font-size: 18px;
    color: #515151;
    font-weight: 400;

}
.frm-cnt-lft{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
}

.frm-cnt-lft{
    font-size: 17px;
    color: #515151;
    font-weight: 400;

}

.work_main_container_xxl{
    display: flex;
    flex-direction: column;
    gap: 4.5rem;
}

@media screen and (max-width: 680px) {
    .work_main-tsc {
      width: 100%;
    }
    .work-grp-btn{
        width: 90%;
    }
    .hw-it-wrk-tlt{
        font-size: 32px;
    }
  }


@media screen and (max-width: 600px){
    .hw-it-wrk-tlt{
        font-size: 32px;
        text-align: center;

    }
    .work_brn1-fns {
        font-size: 20px;
    }
    .frm-img-rgt img {
        width: 95%;
    }
    .work_main_container_xxl{
        gap: 3rem;
    }
    .frm-img-rgt img{
        margin-top: 0px;
    }
    
}
/* @media screen and (max-width: 600px){
    
} */`, "",{"version":3,"sources":["webpack://./src/pages/Home/HowItWork/Index.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI;MACE,WAAW;IACb;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;EACF;;;AAGF;IACI;QACI,eAAe;QACf,kBAAkB;;IAEtB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;;AAEJ;AACA;;GAEG","sourcesContent":[".hw-it-wrk-tlt{\n    font-size: 50px;\n    font-weight: 700;\n    color: #000;\n}\n\n.work_main-tsc{\n    width: 70%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.8rem;\n}\n\n.work-grp-btn{\n    border: 3px solid #234B9A;\n    width: 490px;\n    height: 69px;\n    display: flex;\n    border-radius: 70px;\n}\n.work_brn1-fns{\n    border: none;\n    background-color: transparent;\n    width: 50%;\n    height: 100%;\n    font-size: 32px;\n    font-weight: 600;\n    color: #000;\n}\n\n.farm-btn{\n    border-top-left-radius: 70px;\n    border-bottom-left-radius: 70px;\n    background-color: #234B9A;\n    color: #fff;\n}\n.stack-btn{\n    border-top-right-radius: 70px;\n    border-bottom-right-radius: 70px;\n    background-color: #234B9A;\n    color: #fff;\n}\n\n.frm-img-rgt{\n    display: flex;\n    justify-content: center;\n}\n\n.frm-img-rgt img{\n    width: 100%;\n    margin-top: 2rem;\n}\n.stck-p-txt{\n    font-size: 18px;\n    color: #515151;\n    font-weight: 400;\n\n}\n.frm-cnt-lft{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.frm-cnt-lft{\n    font-size: 17px;\n    color: #515151;\n    font-weight: 400;\n\n}\n\n.work_main_container_xxl{\n    display: flex;\n    flex-direction: column;\n    gap: 4.5rem;\n}\n\n@media screen and (max-width: 680px) {\n    .work_main-tsc {\n      width: 100%;\n    }\n    .work-grp-btn{\n        width: 90%;\n    }\n    .hw-it-wrk-tlt{\n        font-size: 32px;\n    }\n  }\n\n\n@media screen and (max-width: 600px){\n    .hw-it-wrk-tlt{\n        font-size: 32px;\n        text-align: center;\n\n    }\n    .work_brn1-fns {\n        font-size: 20px;\n    }\n    .frm-img-rgt img {\n        width: 95%;\n    }\n    .work_main_container_xxl{\n        gap: 3rem;\n    }\n    .frm-img-rgt img{\n        margin-top: 0px;\n    }\n    \n}\n/* @media screen and (max-width: 600px){\n    \n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
